module.exports = __webpack_public_path__ + "static/media/SF-2-A.dda27c6a.mp3";